export default __webpack_public_path__ + "static/media/JournalBook_Dark2.6069299c.svg";